/**
 * Popover for shopify products choosing on editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import enhanceWithClickOutside from 'react-click-outside'
import AssetsIcon from 'react-icons/lib/fa/file-image-o'
import StyleIcon from 'react-icons/lib/fa/paint-brush'
import * as _ from 'lodash'

import ProductCard from 'components/editor/productCards/ProductCard'
import PopoverHeader from './PopoverHeader'
import CustomTabs from './CustomTabs'
import CustomCSSView from './customCSS/CustomCSSView'
import { setCustomFieldArray } from '../../../controllers/logic'
import { api } from '../../../api/integrationAPI'


const Container = styled.div`
  height: 37em;
  width: 33em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);

  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
`
const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow-y: auto;
`
const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  margin-top: 50px;
`
const ProductsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
`

class ShopifyPopover extends Component {

  constructor (props) {
    super(props)
    const { initialized, products } = this.getShopifyProducts()
    this.state = {
      activeTab: 0,
      products,
      initialized
    }
  }

  componentWillMount () {
    this.props.updatePosition('10%', '46%')
  }

  getShopifyProducts () {
    // console.log('getShopifyProducts')
    if (api.isInitialized()) {
      const products = api.availableProducts()
      const res = []
      for (const p of products) {
        if (p.images.length > 0) {
          const productInfo = {
            id: p.id,
            image: p.images[0].src,
            title: p.title,
            description: p.description
          }
          res.push(productInfo)
        }
      }
      return {initialized: true, products: res}
    } else {
      return {initialized: false, products: []}
    }
  }

  onItemClick = (item) => {
    this.setState({
      activeTab: item.id
    })
  }

  onSelectProduct = (product) => {
    return (e) => {
      const { dispatch, field, app, currentProductId } = this.props
      const paths = field.paths
      // console.log('onSelectProduct, product', product, 'currentProductId', currentProductId)
      if (product.id === currentProductId) {
        console.log('clear current product', paths[0])
        dispatch(setCustomFieldArray(app.id, paths[0], null))
      } else {
        const p = {
          title: product.title,
          productId: product.id
        }
        dispatch(setCustomFieldArray(app.id, paths[0], p))
      }
    }
  }

  renderProduct = (product) => {
    const { currentProductId } = this.props
    const isSelected = product.id === currentProductId
    return (
      <ProductCard
        key={product.id}
        onClick={this.onSelectProduct(product)}
        isSelected={isSelected}
        imageUrl={product.image}
        title={product.title}
      />
    )
  }

  renderShopifyGallery () {
    if (this.state.initialized) {
      return (
        <ProductsContainer>
          {_.map(this.state.products, this.renderProduct)}
        </ProductsContainer>
      )
    } else {
      return (
        <LoaderContainer>
          Sorry, we can't connect to your shopify store.<br />Please, check integration settings.
        </LoaderContainer>
      )
    }
  }

  renderEditCSS () {
    return (
      <CustomCSSView
        field={this.props.field}
        app={this.props.app}
      />
    )
  }


  renderContent () {
    switch (this.state.activeTab) {
      case 0:
        return this.renderShopifyGallery()
      case 1:
        return this.renderEditCSS()
      default:
        return null
    }
  }

  render () {
    const { app, field, title, closeMyself } = this.props
    const tabsInfo = [
      {icon: AssetsIcon, name: 'Shopify products'},
      {icon: StyleIcon, name: 'Style'}
    ]
    return (
      <Container>
        <PopoverHeader
          title={title}
          onClose={closeMyself}
          helpTooltip={'Select the product from your Shopify store.'}
          app={app}
          field={field}
        />
        <Content>
          <CustomTabs
            activeTab={this.state.activeTab}
            onClick={this.onItemClick}
            tabsInfo={tabsInfo}
          />
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}


ShopifyPopover.propTypes = {
  closeMyself: PropTypes.func.isRequired,
  title: PropTypes.string,
  app: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
  currentProductId: PropTypes.number,
}

export default connect()(enhanceWithClickOutside(ShopifyPopover))



// WEBPACK FOOTER //
// ./src/components/editor/popovers/ShopifyPopover.js